import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c(VMain,[_c(VContainer,{staticClass:"fill-height",attrs:{"fluid":""}},[_vm._t("default")],2)],1),_c('snackbar'),_c('span',{staticClass:"px-2 py-1 text-caption grey--text version"},[_vm._v(_vm._s(_vm.version))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }